import { FC } from 'react'
import { Loading } from '../..'

type FormFieldLoadingProps = {
  overlay?: boolean,
  align?: '' | 'center' | 'right' | 'left' | undefined
}

const FormFieldLoading:FC<FormFieldLoadingProps> = ({ overlay = false, align = '' }) => <Loading size="sm" align={align} overlay={overlay} className={`${overlay ? '' : 'mt-5'} py-5`} />

export { FormFieldLoading }